<template>
  <div class="container d-flex py-5 main-container">
    <div class="my-auto w-100 main-area nofound-area text-center">
      <span class="error-logo" style="margin-bottom: 50px; margin-right: 15px">
        <img
          src="./../assets/images/wtiogomark_ra.png"
          alt="logo"
          height="auto"
          width="20%"
          class="img-fluid"
        />
      </span>

      <span class="error-image">
        <img
          src="./../assets/images/maintainance.png"
          alt="logo"
          class="img-fluid"
        />
      </span>

      <!-- <h1>ただいまメンテナンス作業を行っております。</h1> -->
      <p style="white-space: pre-wrap" class="mt-3">{{ maintenance_msg }}</p>
      <!-- <p>大変ご迷惑をおかけいたしますが、ご理解・ご協力のほど、<br />
        よろしくお願い申しあげます。</p>
      <p>Bloomキャリア登録</p> -->
      <!--<div class="btn-toolbar justify-content-center" role="toolbar"-->
      <!--aria-label="Toolbar with button groups">-->
      <!--<router-link :to="{ name: 'login' }" class="btn btn-primary">BACK TO HOME</router-link>-->
      <!--</div>-->
    </div>
    <!-- ends main-area -->
  </div>
</template>
<script>
import Api from '@/config/api';

export default {
  name: 'Maintenance',
  data() {
    return {
      maintenance_msg: '',
      show_msg: false,
    };
  },
  methods: {
    async checkMaintenaceMsg() {
      try {
        const response = await this.axios({
          method: 'get',
          url: Api.url(Api.endpoints.SITE_INFO),
        });

        if (response.data) {
          const resData = response.data;
          if (resData.data.show_msg == true) {
            this.show_msg = resData.data.show_msg;
            this.maintenance_msg = resData.data.maintenance_msg;
          }
        } else {
          this.show_msg = false;
          this.show_msg = '';
        }
      } catch (error) {
        this.show_msg = false;
        this.maintenance_msg = '';
      }
    },
  },
  created() {
    this.checkMaintenaceMsg();
  },
};
</script>
<style>
  .nofound-area h1 {
    font-size: 22px;
    margin-bottom: 30px;
    margin-top: 1%;
    color: #6c6c6e;
  }
  .nofound-area p {
    color: #6c6c6e;
    font-size: 18px;
    margin-bottom: 30px;
    line-height: 25px;
  }
</style>
